<div
  class="wrap_Multiselect-div multiselect-dropdown-box {{ customClass }}"
  [ngClass]="{ notAllowed: disabled }"
  #dropdownContainer
  style="position: relative;"
>
  <!-- Toggle bar -->
  <div
    [ngClass]="{ 'disbaled-dropdown': disabled }"
    class="multiselect_Dropdown_Toggle position-relative multiselect-dropdown"
    [class.multiselect-dropdown-toggle-border-bottom]="showDropDown"
    (click)="toggleDropdown()"
  >
    <div class="selectLable nowrap ps-1">
      <span
        class="text-light-gray tab-view"
        [ngClass]="{ activelistlable: checkedList?.length > 0 }"
      >
        {{ listLabel }}<span *ngIf="required" class="required-feild"> *</span>
      </span>
    </div>

    <div class="selectCheckedData nowrap text-primary-color">
      <span
        class="multiselect-check-list mb-0 overflow-hidden tab-view"
        *ngIf="checkedList?.length > 0"
      >
        <span
          class="d-inline-flex text-truncate w-100px tab-view"
          [ngClass]="checkedList?.length == 1 ? 'dClass' : ''"
        >
          {{
            checkedList.join(', ')
              | slice: 0 : checkedList[0]?.length + checkedList[1]?.length + 3
          }}
        </span>
      </span>
      <span class="show-other-btn text-nowrap tab-view" *ngIf="checkedList?.length > 2">
        ...+{{ checkedList?.length - 2 }} Others
      </span>
    </div>
  </div>

  <!-- Dropdown panel — positioned absolutely by updatePosition() -->
  <div
    #dropdownPanel
    class="show-multiselect-dropdown show-dropdown"
    *ngIf="showDropDown"
  >
    <div
      *ngIf="list?.length !== 0"
      class="bg-light-color optionDropdown px-3 py-2"
      [ngClass]="{ 'd-block': dropdownColOne }"
      (click)="$event.stopPropagation()"
    >
      <span
        *ngFor="let item of list; let i = index"
        class="m-0 p-0 form-check"
      >
        <div class="p-03 d-flex">
          <input
            class="checkbox hand form-check-input"
            type="checkbox"
            [id]="'ms-' + i"
            [checked]="item.isActive"
            [disabled]="isInputDisabled"
            [(ngModel)]="item.isActive"
            (click)="toggle(item); $event.stopPropagation()"
          />
          <label
            [for]="'ms-' + i"
            class="form-check-label mb-0"
            [ngClass]="{
              'theme-color': item.isActive,
              'text-wrap text-break': item.name.length > 10
            }"
          >
            {{ item.name }}
          </label>
        </div>
      </span>
    </div>

    <div
      *ngIf="list?.length === 0"
      class="p-1 d-flex align-items-center justify-content-center text-gray text-truncate f-16 notAllowed"
    >
      No records available
    </div>
  </div>

  <!-- Arrow icon -->
  <span class="multiselect-drowdown hand" (click)="toggleDropdown()">
    <img src="./assets/SVGIcons/lightArrow.svg" alt="" width="13" height="12" />
  </span>

  <!-- Clear icon -->
  <span class="clearLogo hand">
    <app-svg
      iconType="UndoSVG"
      (click)="clearSelectedData()"
      [ngClass]="{ invisible: checkedList?.length <= 0 }"
    ></app-svg>
  </span>
</div>